<template>

    <div>

        <transition name="slide-fade">
            <app-top-bar v-if="topbar"
                         :services="services"
                         @setParentService="service = $event"
                         @openOrderModal="orderModal = true">
                ></app-top-bar>
        </transition>

        <div @click="ddfk_loc_open = false; ddfk_type_open = false; ddfk_size_open = false;">
            <section id="f-lv1-search" class="section" :style="'background-image:url(\''+banner+'\');'">

                <div class="icontitle">
                    <div>
                        <img :src="$route.meta.icon" alt="">
                    </div>
                    <h2 v-html="$route.meta.title">
                    </h2>

                </div>
                <div class="container">

                    <div class="columns">
                        <div class="column"></div>
                        <div class="column is-four-fifths-tablet">

                            <search-drop-down
                                    :services="services"
                                    @setParentService="service = $event"
                                    @openOrderModal="orderModal = true">

                            </search-drop-down>
                        </div>
                        <div class="column"></div>
                    </div>
                </div>


            </section>




            <section id="featured">

                <div class="searchbar">

                    <div class="container">

                        <div class="searchbarbtn">

                            <div class="fakeddcontainer">
                                <p class="fakedd" @click.stop="ddfk_type_open = true; ddfk_loc_open = false; ddfk_size_open = false;"> {{typeopt[type]}}
                                    <i class="fa fa-angle-down pull-right" style="line-height: 2rem; color:#ffffff"></i>
                                </p>

                                <input id="type" type="text"  :value="typeopt[type]" name="type" placeholder="Tipo de Imóvel" style="display: none;">
                                <div v-if="ddfk_type_open" class="ddfake-open">
                                    <p v-for="t, index in typeopt" v-if="index > 0" class="ddfake-opt" @click="type = index; ddfk_type_open = false; [1,2].indexOf(type) === -1 ? size = 0: null">{{typeopt[index]}}</p>

                                </div>
                            </div>

                            <div class="fakeddcontainer">
                                <p class="fakedd" :class="{'gray': [1,2].indexOf(type) === -1}" @click.stop="ddfk_size_open = true; ddfk_loc_open = false; ddfk_type_open = false;"> {{sizeopt[size]}} <i class="fa fa-angle-down pull-right" style="line-height: 2rem; color:#ffffff"></i></p>
                                <input id="size" type="text"  :value="sizeopt[size]" name="size" placeholder="Tipologia" style="display: none;">
                                <div v-if="ddfk_size_open && [1,2].indexOf(type) !== -1" class="ddfake-open">
                                    <p v-for="s, index in sizeopt" v-if="index > 0" class="ddfake-opt" @click="size = index; ddfk_size_open = false;">{{sizeopt[index]}}</p>

                                </div>
                            </div>

                            <place-drop-down @setPlace="setPlace($event)"></place-drop-down>

                            <div id="sortbar">

                                <div class="orderby">
                                    <span>Ordenar por: &nbsp;</span>


                                    <div class="orderbysub">
                                        <a class="sort" :class="{'selected': sort===1}" @click="sort=1">
                                            <svg version="1.1" id="Layer_1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px"
	 width="39.361px" height="39.362px" viewBox="0 0 39.361 39.362" enable-background="new 0 0 39.361 39.362" xml:space="preserve">
<rect fill="currentColor" width="39.361" height="38.362"/>
<path fill="#FFFFFF" d="M20.569,28.114c0.055,0.219-0.069,0.439-0.274,0.508c-0.056,0.014-1.333,0.453-2.98,0.453
	c-4.285,0-7.731-2.582-8.885-6.619H7.125c-0.248,0-0.439-0.206-0.439-0.439v-1.552c0-0.233,0.191-0.439,0.439-0.439h0.906
	c-0.014-0.439-0.014-0.961,0.014-1.442h-0.92c-0.248,0-0.439-0.192-0.439-0.439v-1.565c0-0.247,0.191-0.439,0.439-0.439h1.346
	c1.222-3.845,4.737-6.399,8.844-6.399c1.428,0,2.609,0.302,2.664,0.316c0.109,0.027,0.206,0.11,0.274,0.206
	c0.056,0.096,0.069,0.22,0.042,0.33l-0.591,2.184c-0.056,0.233-0.288,0.371-0.522,0.302c-0.014,0-0.947-0.233-1.922-0.233
	c-2.308,0-4.244,1.25-5.164,3.296h6.427c0.138,0,0.261,0.055,0.344,0.165c0.082,0.096,0.124,0.233,0.096,0.357l-0.329,1.565
	c-0.041,0.206-0.22,0.357-0.439,0.357h-6.702c-0.041,0.439-0.027,0.907,0,1.442h6.304c0.138,0,0.261,0.068,0.344,0.165
	c0.082,0.11,0.109,0.248,0.082,0.371l-0.33,1.538c-0.041,0.206-0.219,0.357-0.426,0.357H12.15c0.879,2.143,2.856,3.488,5.191,3.488
	c1.195,0,2.17-0.33,2.184-0.33c0.109-0.041,0.247-0.027,0.357,0.027c0.109,0.069,0.178,0.179,0.205,0.289L20.569,28.114z"/>
<path fill="#FFFFFF" d="M32.441,10.75h-1.613v8.988c0,0.129-0.101,0.23-0.23,0.23h-1.383c-0.13,0-0.23-0.101-0.23-0.23V10.75h-1.613
	c-0.094,0-0.173-0.05-0.209-0.137s-0.021-0.18,0.036-0.252l2.521-2.766c0.043-0.043,0.102-0.072,0.166-0.072l0,0
	c0.064,0,0.13,0.029,0.173,0.072l2.557,2.766c0.058,0.072,0.072,0.166,0.036,0.252C32.614,10.693,32.535,10.75,32.441,10.75z"/>
</svg>
                                        </a>
                                        <a class="sort" :class="{'selected': sort===2}" @click="sort=2">
                                            <svg version="1.1" id="Layer_1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px"
	 width="39.361px" height="39.362px" viewBox="0 0 39.361 39.362" enable-background="new 0 0 39.361 39.362" xml:space="preserve">
<g opacity="1">
	<g>
		<defs>
			<rect id="SVGID_1_" x="0.67" y="-0.33" width="39.37" height="39.37"/>
		</defs>
		<clipPath id="SVGID_2_">
			<use xlink:href="#SVGID_1_"  overflow="visible"/>
		</clipPath>
		<rect x="0.674" y="-0.327" clip-path="url(#SVGID_2_)" fill="currentColor" width="39.362" height="39.362"/>
	</g>
</g>
<g opacity="0.8">
	<g>
		<defs>
			<rect id="SVGID_3_" x="28.04" y="6.43" width="5.54" height="13.22"/>
		</defs>
		<clipPath id="SVGID_4_">
			<use xlink:href="#SVGID_3_"  overflow="visible"/>
		</clipPath>
		<g clip-path="url(#SVGID_4_)">
			<path opacity="0.8" fill="#EEEDEC" d="M33.516,16.344l-2.521,2.766c-0.044,0.043-0.101,0.072-0.166,0.072l0,0
				c-0.064,0-0.13-0.029-0.173-0.072L28.1,16.344c-0.058-0.072-0.072-0.166-0.036-0.252c0.036-0.079,0.115-0.137,0.209-0.137h1.613
				V6.966c0-0.129,0.101-0.23,0.23-0.23h1.383c0.13,0,0.23,0.101,0.23,0.23v8.988h1.613c0.094,0,0.173,0.05,0.209,0.137
				S33.573,16.271,33.516,16.344z"/>
		</g>
	</g>
</g>
<path fill="#EEEDEC" d="M21.471,27.786c0.055,0.221-0.069,0.439-0.275,0.509c-0.055,0.014-1.332,0.453-2.979,0.453
	c-4.285,0-7.731-2.582-8.886-6.619H8.025c-0.247,0-0.439-0.206-0.439-0.439v-1.552c0-0.233,0.192-0.439,0.439-0.439h0.907
	c-0.015-0.439-0.015-0.961,0.014-1.442H8.025c-0.247,0-0.439-0.192-0.439-0.439v-1.565c0-0.247,0.192-0.439,0.439-0.439h1.347
	c1.222-3.845,4.737-6.399,8.844-6.399c1.428,0,2.609,0.302,2.664,0.316c0.11,0.027,0.206,0.11,0.274,0.206
	c0.055,0.096,0.068,0.22,0.041,0.33l-0.59,2.184c-0.055,0.233-0.289,0.371-0.522,0.302c-0.014,0-0.947-0.233-1.922-0.233
	c-2.308,0-4.244,1.25-5.164,3.296h6.427c0.138,0,0.262,0.055,0.344,0.165c0.082,0.096,0.123,0.233,0.096,0.357l-0.329,1.565
	c-0.041,0.206-0.22,0.357-0.439,0.357h-6.702c-0.041,0.439-0.027,0.907,0,1.442h6.304c0.138,0,0.261,0.068,0.344,0.165
	c0.082,0.11,0.109,0.248,0.082,0.371l-0.329,1.538c-0.042,0.206-0.221,0.357-0.426,0.357h-5.315
	c0.879,2.142,2.856,3.488,5.191,3.488c1.194,0,2.17-0.33,2.184-0.33c0.11-0.041,0.247-0.027,0.356,0.028
	c0.11,0.068,0.179,0.178,0.207,0.288L21.471,27.786z"/>
</svg>
                                        </a>
                                    </div>

                                    <div class="orderbysub">
                                        <a class="sort" :class="{'selected': sort===3}" @click="sort=3">
                                            <svg version="1.1" id="Layer_1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px"
	 width="39.361px" height="39.362px" viewBox="0 0 39.361 39.362" enable-background="new 0 0 39.361 39.362" xml:space="preserve">
<g opacity="1">
	<g>
		<defs>
			<rect id="SVGID_1_" x="0.67" y="-0.33" width="39.37" height="39.37"/>
		</defs>
		<clipPath id="SVGID_2_">
			<use xlink:href="#SVGID_1_"  overflow="visible"/>
		</clipPath>
		<rect x="0.674" y="-0.327" clip-path="url(#SVGID_2_)" fill="currentColor" width="39.362" height="39.362"/>
	</g>
</g>
<g opacity="0.8">
	<g>
		<defs>
			<rect id="SVGID_3_" x="27.81" y="6.43" width="5.54" height="13.22"/>
		</defs>
		<clipPath id="SVGID_4_">
			<use xlink:href="#SVGID_3_"  overflow="visible"/>
		</clipPath>
		<g clip-path="url(#SVGID_4_)">
			<path opacity="0.8" fill="#EEEDEC" d="M33.115,10.423h-1.613v8.988c0,0.129-0.101,0.23-0.23,0.23h-1.383
				c-0.129,0-0.23-0.101-0.23-0.23v-8.988h-1.613c-0.093,0-0.172-0.05-0.208-0.137s-0.022-0.18,0.036-0.252l2.521-2.766
				c0.043-0.043,0.101-0.072,0.165-0.072l0,0c0.065,0,0.13,0.029,0.173,0.072l2.558,2.766c0.057,0.072,0.071,0.166,0.035,0.252
				C33.289,10.366,33.209,10.423,33.115,10.423z"/>
		</g>
	</g>
</g>
<path fill="#EEEDEC" d="M21.731,9.488H6.053c-0.156,0-0.283,0.126-0.283,0.282v0.905c0,0.156,0.127,0.283,0.283,0.283h0.621v8.461
	v1.508v1.508v1.508v3.336H6.655c-0.156,0-0.283,0.127-0.283,0.282v0.904c0,0.156,0.127,0.283,0.283,0.283h14.474
	c0.155,0,0.282-0.127,0.282-0.283v-0.904c0-0.155-0.127-0.282-0.282-0.282h-0.02v-3.034v-1.509v-1.508v-1.507v-8.763h0.622
	c0.156,0,0.283-0.127,0.283-0.283V9.77C22.015,9.614,21.888,9.488,21.731,9.488 M14.174,11.58c0-0.343,0.279-0.622,0.623-0.622h3.92
	c0.343,0,0.621,0.279,0.621,0.622v1.507c0,0.343-0.278,0.622-0.621,0.622h-0.02v-0.32c0-0.489-0.396-0.886-0.886-0.886h-1.206
	h-1.206c-0.488,0-0.886,0.397-0.886,0.886v0.251c-0.201-0.103-0.34-0.312-0.34-0.553V11.58z M15.78,13.068h0.708l1.244,1.244h-0.708
	L15.78,13.068z M16.225,14.312h-0.825c-0.177,0-0.32-0.144-0.32-0.32v-0.604c0-0.071,0.023-0.136,0.062-0.188
	c0.014,0.031,0.033,0.06,0.059,0.086L16.225,14.312z M17.288,13.068h0.523c0.177,0,0.321,0.144,0.321,0.321v0.523L17.288,13.068z
	 M8.445,11.58c0-0.343,0.279-0.622,0.622-0.622h3.92c0.343,0,0.622,0.279,0.622,0.622v1.507c0,0.241-0.138,0.45-0.339,0.553v-0.251
	c0-0.489-0.398-0.886-0.886-0.886h-1.206H9.973c-0.489,0-0.887,0.397-0.887,0.886v0.32H9.067c-0.343,0-0.622-0.279-0.622-0.622
	V11.58z M10.353,13.068h0.709l1.243,1.244h-0.708L10.353,13.068z M10.797,14.312H9.973c-0.178,0-0.321-0.144-0.321-0.32v-0.604
	c0-0.071,0.022-0.136,0.062-0.188c0.015,0.031,0.033,0.06,0.06,0.086L10.797,14.312z M11.86,13.068h0.524
	c0.176,0,0.319,0.144,0.319,0.321v0.523L11.86,13.068z M20.545,18.662H7.239v-0.401h0.32h1.508h1.508h1.507h1.508h1.508h0.001h1.507
	h1.508h1.507h0.001h0.924V18.662z M20.545,17.634H7.239v-6.676h0.817c-0.112,0.181-0.176,0.394-0.176,0.622v1.507
	c0,0.655,0.531,1.187,1.187,1.187h0.065c0.118,0.351,0.449,0.603,0.84,0.603h2.412c0.398,0,0.736-0.265,0.847-0.628
	c0.262-0.055,0.493-0.197,0.66-0.394c0.168,0.197,0.397,0.339,0.661,0.394c0.109,0.363,0.447,0.628,0.847,0.628h2.412
	c0.39,0,0.721-0.252,0.84-0.603h0.065c0.654,0,1.187-0.532,1.187-1.187V11.58c0-0.229-0.063-0.441-0.176-0.622h0.817V17.634z"/>
</svg>

                                        </a>
                                        <a class="sort" :class="{'selected': sort===4}" @click="sort=4">
                                            <svg version="1.1" id="Layer_1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px"
	 width="39.361px" height="39.362px" viewBox="0 0 39.361 39.362" enable-background="new 0 0 39.361 39.362" xml:space="preserve">
<g opacity="1">
	<g>
		<defs>
			<rect id="SVGID_1_" x="0.04" y="-0.33" width="39.36" height="39.37"/>
		</defs>
		<clipPath id="SVGID_2_">
			<use xlink:href="#SVGID_1_"  overflow="visible"/>
		</clipPath>
		<rect x="0.036" y="-0.327" clip-path="url(#SVGID_2_)" fill="currentColor" width="39.361" height="39.362"/>
	</g>
</g>
<g opacity="0.8">
	<g>
		<defs>
			<rect id="SVGID_3_" x="27.18" y="6.43" width="5.53" height="13.22"/>
		</defs>
		<clipPath id="SVGID_4_">
			<use xlink:href="#SVGID_3_"  overflow="visible"/>
		</clipPath>
		<g clip-path="url(#SVGID_4_)">
			<path opacity="0.8" fill="#EEEDEC" d="M32.65,16.344l-2.521,2.766c-0.043,0.043-0.101,0.072-0.165,0.072l0,0
				c-0.065,0-0.13-0.029-0.173-0.072l-2.558-2.766c-0.057-0.072-0.071-0.166-0.035-0.252c0.035-0.079,0.115-0.137,0.209-0.137h1.613
				V6.966c0-0.129,0.101-0.23,0.23-0.23h1.383c0.129,0,0.23,0.101,0.23,0.23v8.988h1.613c0.093,0,0.172,0.05,0.208,0.137
				S32.709,16.271,32.65,16.344z"/>
		</g>
	</g>
</g>
<path fill="#EEEDEC" d="M21.703,9.521H6.052c-0.156,0-0.282,0.126-0.282,0.282v0.903c0,0.156,0.126,0.282,0.282,0.282h0.621v8.447
	v1.505v1.505v1.505v3.33h-0.02c-0.155,0-0.282,0.126-0.282,0.282v0.903c0,0.155,0.127,0.281,0.282,0.281h14.448
	c0.156,0,0.282-0.126,0.282-0.281v-0.903c0-0.156-0.126-0.282-0.282-0.282h-0.019v-3.029v-1.505v-1.505v-1.505v-8.748h0.62
	c0.156,0,0.282-0.126,0.282-0.282V9.804C21.985,9.647,21.859,9.521,21.703,9.521 M14.16,11.609c0-0.342,0.278-0.621,0.62-0.621
	h3.913c0.342,0,0.621,0.279,0.621,0.621v1.505c0,0.342-0.279,0.621-0.621,0.621h-0.019v-0.32c0-0.488-0.396-0.884-0.884-0.884
	h-1.204h-1.204c-0.488,0-0.884,0.396-0.884,0.884v0.251c-0.201-0.103-0.339-0.311-0.339-0.552V11.609z M15.763,13.096h0.707
	l1.242,1.242h-0.707L15.763,13.096z M16.207,14.337h-0.824c-0.176,0-0.32-0.144-0.32-0.32v-0.602c0-0.07,0.023-0.135,0.062-0.188
	c0.014,0.031,0.032,0.061,0.059,0.086L16.207,14.337z M17.268,13.096h0.523c0.176,0,0.319,0.144,0.319,0.32v0.523L17.268,13.096z
	 M8.44,11.609c0-0.342,0.279-0.621,0.621-0.621h3.913c0.342,0,0.621,0.279,0.621,0.621v1.505c0,0.241-0.138,0.449-0.339,0.552
	v-0.251c0-0.488-0.396-0.884-0.884-0.884h-1.204H9.965c-0.488,0-0.885,0.396-0.885,0.884v0.32H9.062
	c-0.342,0-0.621-0.279-0.621-0.621V11.609z M10.345,13.096h0.707l1.242,1.242h-0.707L10.345,13.096z M10.789,14.337H9.965
	c-0.176,0-0.32-0.144-0.32-0.32v-0.602c0-0.07,0.023-0.135,0.062-0.188c0.013,0.031,0.032,0.061,0.058,0.086L10.789,14.337z
	 M11.85,13.096h0.523c0.176,0,0.319,0.144,0.319,0.32v0.523L11.85,13.096z M20.519,18.68H7.236v-0.4h0.32h1.505h1.505h1.505h1.505
	h1.506h1.505h1.505h1.505h0.922V18.68z M20.519,17.653H7.236v-6.665h0.816c-0.112,0.181-0.176,0.394-0.176,0.621v1.505
	c0,0.654,0.53,1.186,1.185,1.186h0.065c0.117,0.35,0.448,0.602,0.838,0.602h2.408c0.397,0,0.735-0.265,0.846-0.627
	c0.262-0.055,0.492-0.197,0.659-0.394c0.167,0.197,0.396,0.339,0.659,0.394c0.109,0.362,0.447,0.627,0.846,0.627h2.408
	c0.389,0,0.72-0.252,0.838-0.602h0.064c0.654,0,1.186-0.531,1.186-1.186v-1.505c0-0.227-0.064-0.44-0.176-0.621h0.815V17.653z"/>
</svg>

                                        </a>
                                    </div>

                                    <div class="orderbysub">
                                        <a class="sort" :class="{'selected': sort===5}" @click="sort=5">
                                            <svg version="1.1" id="Layer_1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px"
	 width="39.361px" height="39.362px" viewBox="0 0 39.361 39.362" enable-background="new 0 0 39.361 39.362" xml:space="preserve">
<g opacity="1">
	<g>
		<defs>
			<rect id="SVGID_1_" x="0.54" y="-0.33" width="39.36" height="39.37"/>
		</defs>
		<clipPath id="SVGID_2_">
			<use xlink:href="#SVGID_1_"  overflow="visible"/>
		</clipPath>
		<rect x="0.536" y="-0.327" clip-path="url(#SVGID_2_)" fill="currentColor" width="39.361" height="39.362"/>
	</g>
</g>
<g opacity="0.8">
	<g>
		<defs>
			<rect id="SVGID_3_" x="27.68" y="6.43" width="5.53" height="13.22"/>
		</defs>
		<clipPath id="SVGID_4_">
			<use xlink:href="#SVGID_3_"  overflow="visible"/>
		</clipPath>
		<g clip-path="url(#SVGID_4_)">
			<path opacity="0.8" fill="#EEEDEC" d="M32.979,10.423h-1.613v8.988c0,0.129-0.102,0.23-0.23,0.23h-1.383
				c-0.13,0-0.23-0.101-0.23-0.23v-8.988h-1.613c-0.094,0-0.174-0.05-0.209-0.137c-0.036-0.086-0.021-0.18,0.035-0.252l2.521-2.766
				c0.043-0.043,0.101-0.072,0.165-0.072l0,0c0.065,0,0.13,0.029,0.173,0.072l2.557,2.766c0.059,0.072,0.072,0.166,0.036,0.252
				C33.15,10.366,33.071,10.423,32.979,10.423z"/>
		</g>
	</g>
</g>
<path fill="#EEEDEC" d="M20.28,14.597c-0.139,0-0.272-0.056-0.369-0.152c-0.1-0.1-0.154-0.231-0.153-0.371
	c0-0.14,0.054-0.271,0.153-0.37l3.051-3.067h-1.375c-0.288,0-0.522-0.234-0.522-0.522s0.234-0.523,0.522-0.523h2.636
	c0.066,0,0.13,0.013,0.192,0.037l0.005,0.002c0.128,0.052,0.232,0.156,0.286,0.285c0.028,0.075,0.04,0.136,0.04,0.199v2.636
	c0,0.288-0.235,0.523-0.523,0.523c-0.289,0-0.523-0.235-0.523-0.523v-1.371l-3.049,3.066C20.551,14.543,20.42,14.597,20.28,14.597"
	/>
<path fill="#EEEDEC" d="M9.9,14.597c-0.14,0-0.271-0.054-0.369-0.152l-3.05-3.066v1.371c0,0.288-0.235,0.523-0.524,0.523
	c-0.288,0-0.521-0.235-0.521-0.523v-2.636c0-0.062,0.012-0.123,0.035-0.189C5.528,9.785,5.632,9.681,5.76,9.629l0.006-0.002
	C5.828,9.603,5.893,9.59,5.957,9.59h2.636c0.288,0,0.522,0.235,0.522,0.523s-0.234,0.522-0.522,0.522H7.219l3.052,3.068
	c0.098,0.098,0.152,0.229,0.152,0.369c0,0.14-0.054,0.271-0.153,0.371C10.173,14.541,10.038,14.597,9.9,14.597"/>
<path fill="#EEEDEC" d="M21.587,28.901c-0.288,0-0.521-0.235-0.521-0.523c0-0.287,0.233-0.522,0.521-0.522h1.374l-3.051-3.068
	c-0.098-0.098-0.153-0.229-0.153-0.369c0-0.14,0.055-0.271,0.154-0.37c0.096-0.098,0.231-0.153,0.369-0.153
	c0.139,0,0.271,0.054,0.37,0.153l3.049,3.065v-1.37c0-0.289,0.235-0.523,0.524-0.523c0.288,0,0.521,0.234,0.521,0.523v2.635
	c0,0.063-0.011,0.125-0.036,0.189c-0.057,0.139-0.161,0.243-0.289,0.295l-0.006,0.002c-0.061,0.025-0.125,0.037-0.19,0.037H21.587z"
	/>
<path fill="#EEEDEC" d="M5.957,28.901c-0.065,0-0.13-0.012-0.19-0.037l-0.006-0.002c-0.128-0.052-0.232-0.156-0.285-0.284
	c-0.029-0.076-0.041-0.138-0.041-0.2v-2.635c0-0.289,0.235-0.523,0.522-0.523c0.289,0,0.524,0.234,0.524,0.523v1.37l3.049-3.065
	c0.1-0.1,0.23-0.153,0.37-0.153c0.138,0,0.272,0.056,0.37,0.153c0.098,0.099,0.152,0.23,0.152,0.37c0,0.141-0.055,0.271-0.153,0.37
	l-3.05,3.067h1.374c0.288,0,0.521,0.235,0.521,0.522c0,0.288-0.233,0.523-0.521,0.523H5.957z"/>
<path fill="#EEEDEC" d="M20.683,25.365c-0.142,0-0.273-0.056-0.373-0.155L9.125,14.026c-0.1-0.1-0.154-0.232-0.154-0.372
	c0-0.142,0.055-0.274,0.154-0.373c0.1-0.1,0.232-0.155,0.372-0.155c0.142,0,0.273,0.055,0.373,0.155l11.186,11.184
	c0.205,0.206,0.205,0.54,0,0.745C20.955,25.31,20.823,25.365,20.683,25.365"/>
<path fill="#EEEDEC" d="M20.683,22.569c-0.142,0-0.273-0.056-0.373-0.154l-8.388-8.389c-0.101-0.099-0.155-0.232-0.155-0.373
	s0.055-0.273,0.155-0.372c0.1-0.1,0.231-0.154,0.373-0.154c0.14,0,0.272,0.054,0.371,0.154l8.39,8.388
	c0.205,0.206,0.205,0.54,0,0.745C20.955,22.514,20.823,22.569,20.683,22.569"/>
<path fill="#EEEDEC" d="M17.887,25.365c-0.142,0-0.273-0.056-0.373-0.155l-8.389-8.388c-0.1-0.099-0.154-0.232-0.154-0.373
	c0-0.141,0.055-0.273,0.154-0.372c0.101-0.1,0.232-0.155,0.373-0.155s0.273,0.055,0.372,0.155l8.39,8.388
	c0.204,0.206,0.204,0.54,0,0.745C18.159,25.31,18.027,25.365,17.887,25.365"/>
<path fill="#EEEDEC" d="M20.683,19.772c-0.142,0-0.273-0.055-0.373-0.153l-5.592-5.593c-0.205-0.205-0.205-0.54,0-0.745
	c0.1-0.099,0.231-0.154,0.373-0.154c0.14,0,0.272,0.054,0.372,0.154l5.593,5.592c0.205,0.206,0.205,0.54,0,0.745
	C20.955,19.718,20.823,19.772,20.683,19.772"/>
<path fill="#EEEDEC" d="M15.09,25.365c-0.141,0-0.272-0.056-0.373-0.155l-5.592-5.592c-0.1-0.099-0.154-0.232-0.154-0.372
	c0-0.141,0.055-0.274,0.154-0.373c0.101-0.1,0.232-0.154,0.373-0.154s0.273,0.055,0.372,0.154l5.593,5.592
	c0.205,0.206,0.205,0.54,0,0.745C15.363,25.31,15.231,25.365,15.09,25.365"/>
<path fill="#EEEDEC" d="M20.683,16.977c-0.142,0-0.273-0.055-0.373-0.155l-2.796-2.796c-0.101-0.099-0.154-0.231-0.154-0.372
	s0.054-0.272,0.154-0.373c0.1-0.099,0.231-0.154,0.373-0.154c0.141,0,0.272,0.055,0.372,0.154l2.797,2.796
	c0.099,0.1,0.153,0.232,0.153,0.373s-0.055,0.273-0.153,0.372C20.955,16.922,20.823,16.977,20.683,16.977"/>
<path fill="#EEEDEC" d="M12.294,25.364c-0.141,0-0.272-0.055-0.373-0.154l-2.796-2.795c-0.099-0.1-0.155-0.232-0.155-0.373
	s0.057-0.273,0.155-0.373c0.1-0.1,0.232-0.154,0.373-0.154s0.272,0.055,0.373,0.154l2.796,2.797c0.099,0.1,0.154,0.232,0.154,0.372
	c0,0.141-0.056,0.272-0.154,0.372C12.567,25.31,12.434,25.364,12.294,25.364"/>
</svg>

                                        </a>
                                        <a class="sort" :class="{'selected': sort===6}" @click="sort=6">
                                            <svg version="1.1" id="Layer_1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px"
	 width="39.361px" height="39.362px" viewBox="0 0 39.361 39.362" enable-background="new 0 0 39.361 39.362" xml:space="preserve">
<g opacity="1">
	<g>
		<defs>
			<rect id="SVGID_1_" x="0.9" y="-0.33" width="39.359" height="39.37"/>
		</defs>
		<clipPath id="SVGID_2_">
			<use xlink:href="#SVGID_1_"  overflow="visible"/>
		</clipPath>
		<rect x="0.898" y="-0.327" clip-path="url(#SVGID_2_)" fill="currentColor" width="39.362" height="39.362"/>
	</g>
</g>
<g opacity="0.8">
	<g>
		<defs>
			<rect id="SVGID_3_" x="28.04" y="6.43" width="5.54" height="13.22"/>
		</defs>
		<clipPath id="SVGID_4_">
			<use xlink:href="#SVGID_3_"  overflow="visible"/>
		</clipPath>
		<g clip-path="url(#SVGID_4_)">
			<path opacity="0.8" fill="#EEEDEC" d="M33.514,16.344l-2.521,2.766c-0.043,0.043-0.101,0.072-0.165,0.072l0,0
				c-0.065,0-0.13-0.029-0.173-0.072l-2.557-2.766c-0.059-0.072-0.072-0.166-0.036-0.252c0.036-0.079,0.115-0.137,0.208-0.137h1.613
				V6.966c0-0.129,0.102-0.23,0.23-0.23h1.383c0.13,0,0.23,0.101,0.23,0.23v8.988h1.613c0.094,0,0.174,0.05,0.209,0.137
				C33.585,16.178,33.57,16.271,33.514,16.344z"/>
		</g>
	</g>
</g>
<path fill="#EEEDEC" d="M21.477,14.597c-0.138,0-0.271-0.056-0.368-0.152c-0.1-0.1-0.154-0.231-0.153-0.371
	c0-0.14,0.054-0.271,0.153-0.37l3.051-3.067h-1.375c-0.288,0-0.522-0.234-0.522-0.522s0.234-0.523,0.522-0.523h2.636
	c0.066,0,0.13,0.013,0.192,0.037l0.005,0.002c0.128,0.052,0.232,0.156,0.286,0.285c0.027,0.075,0.04,0.136,0.04,0.199v2.636
	c0,0.288-0.235,0.523-0.523,0.523c-0.289,0-0.523-0.235-0.523-0.523v-1.371l-3.05,3.066C21.748,14.543,21.617,14.597,21.477,14.597"
	/>
<path fill="#EEEDEC" d="M11.098,14.597c-0.14,0-0.271-0.054-0.369-0.152l-3.051-3.066v1.371c0,0.288-0.234,0.523-0.523,0.523
	c-0.288,0-0.522-0.235-0.522-0.523v-2.636c0-0.062,0.013-0.123,0.036-0.189c0.058-0.139,0.161-0.243,0.289-0.295l0.006-0.002
	C7.025,9.603,7.089,9.59,7.154,9.59H9.79c0.288,0,0.522,0.235,0.522,0.523s-0.234,0.522-0.522,0.522H8.416l3.051,3.068
	c0.099,0.098,0.153,0.229,0.153,0.369c0,0.14-0.054,0.271-0.154,0.371C11.37,14.541,11.235,14.597,11.098,14.597"/>
<path fill="#EEEDEC" d="M22.784,28.901c-0.288,0-0.521-0.235-0.521-0.523c0-0.287,0.233-0.522,0.521-0.522h1.374l-3.051-3.068
	c-0.098-0.098-0.153-0.229-0.153-0.369c0-0.14,0.055-0.271,0.154-0.37c0.096-0.098,0.231-0.153,0.369-0.153
	c0.139,0,0.271,0.054,0.37,0.153l3.049,3.065v-1.37c0-0.289,0.234-0.523,0.523-0.523c0.288,0,0.522,0.234,0.522,0.523v2.635
	c0,0.063-0.011,0.125-0.036,0.189c-0.057,0.139-0.161,0.243-0.289,0.295l-0.006,0.002c-0.061,0.025-0.125,0.037-0.191,0.037H22.784z
	"/>
<path fill="#EEEDEC" d="M7.154,28.901c-0.065,0-0.13-0.012-0.19-0.037l-0.006-0.002c-0.128-0.052-0.232-0.156-0.285-0.284
	c-0.029-0.076-0.041-0.138-0.041-0.2v-2.635c0-0.289,0.234-0.523,0.522-0.523c0.289,0,0.524,0.234,0.524,0.523v1.37l3.049-3.065
	c0.099-0.1,0.23-0.153,0.37-0.153c0.138,0,0.271,0.056,0.37,0.153c0.098,0.099,0.151,0.23,0.151,0.37
	c0,0.141-0.054,0.271-0.152,0.37l-3.05,3.067h1.374c0.287,0,0.521,0.235,0.521,0.522c0,0.288-0.234,0.523-0.521,0.523H7.154z"/>
<path fill="#EEEDEC" d="M21.88,25.365c-0.142,0-0.273-0.056-0.373-0.155L10.322,14.026c-0.1-0.1-0.154-0.232-0.154-0.372
	c0-0.142,0.055-0.274,0.154-0.373c0.1-0.1,0.232-0.155,0.372-0.155c0.142,0,0.273,0.055,0.373,0.155l11.186,11.184
	c0.204,0.206,0.204,0.54,0,0.745C22.152,25.31,22.021,25.365,21.88,25.365"/>
<path fill="#EEEDEC" d="M21.88,22.569c-0.142,0-0.273-0.056-0.373-0.154l-8.389-8.389c-0.1-0.099-0.154-0.232-0.154-0.373
	s0.055-0.273,0.154-0.372c0.101-0.1,0.232-0.154,0.373-0.154s0.273,0.054,0.372,0.154l8.39,8.388c0.204,0.206,0.204,0.54,0,0.745
	C22.152,22.514,22.021,22.569,21.88,22.569"/>
<path fill="#EEEDEC" d="M19.084,25.365c-0.142,0-0.273-0.056-0.373-0.155l-8.389-8.388c-0.1-0.099-0.154-0.232-0.154-0.373
	c0-0.141,0.055-0.273,0.154-0.372c0.101-0.1,0.232-0.155,0.373-0.155s0.273,0.055,0.372,0.155l8.389,8.388
	c0.205,0.206,0.205,0.54,0,0.745C19.356,25.31,19.225,25.365,19.084,25.365"/>
<path fill="#EEEDEC" d="M21.88,19.772c-0.142,0-0.273-0.055-0.373-0.153l-5.593-5.593c-0.204-0.205-0.204-0.54,0-0.745
	c0.101-0.099,0.232-0.154,0.373-0.154s0.273,0.054,0.372,0.154l5.594,5.592c0.204,0.206,0.204,0.54,0,0.745
	C22.152,19.718,22.021,19.772,21.88,19.772"/>
<path fill="#EEEDEC" d="M16.287,25.365c-0.141,0-0.272-0.056-0.373-0.155l-5.592-5.592c-0.1-0.099-0.155-0.232-0.155-0.372
	c0-0.141,0.056-0.274,0.155-0.373c0.1-0.1,0.232-0.154,0.373-0.154s0.273,0.055,0.372,0.154l5.593,5.592
	c0.205,0.206,0.205,0.54,0,0.745C16.561,25.31,16.429,25.365,16.287,25.365"/>
<path fill="#EEEDEC" d="M21.88,16.977c-0.142,0-0.273-0.055-0.373-0.155l-2.796-2.796c-0.101-0.099-0.154-0.231-0.154-0.372
	s0.054-0.272,0.154-0.373c0.1-0.099,0.231-0.154,0.373-0.154c0.141,0,0.272,0.055,0.371,0.154l2.798,2.796
	c0.099,0.1,0.153,0.232,0.153,0.373s-0.055,0.273-0.153,0.372C22.152,16.922,22.021,16.977,21.88,16.977"/>
<path fill="#EEEDEC" d="M13.491,25.364c-0.141,0-0.272-0.055-0.373-0.154l-2.796-2.795c-0.1-0.1-0.155-0.232-0.155-0.373
	s0.056-0.273,0.155-0.373s0.232-0.154,0.373-0.154s0.272,0.055,0.372,0.154l2.797,2.797c0.099,0.1,0.154,0.232,0.154,0.372
	c0,0.141-0.056,0.272-0.154,0.372C13.765,25.31,13.631,25.364,13.491,25.364"/>
</svg>
                                        </a>
                                    </div>

                                </div>


                            </div>

                        </div>

                    </div>

                </div>

                <div class="searchresults">

                    <div class="container">


                        <h1>IMÓVEIS DESTACADOS</h1>


                        <div>
                            <div class="columns">
                                <div class="column">
                                    <div class="re-img" style="background-image: url('/static/images/feat_property/casa.jpg'); background-position: center; background-size: cover">
                                        <div class="re-card" >
                                            <p class="res_price">150 000,00 €</p>
                                            <p class="res_title"> MORADIA T4</p>
                                            <p class="res_sub"> TELHEIRO | BARREIRA | LEIRIA</p>
                                        </div>
                                    </div>
                                </div>
                                <div class="column">
                                    <div class="re-img" style="background-image: url('/static/images/feat_property/casa.jpg'); background-position: center; background-size: cover">
                                        <div class="re-card" >
                                            <p class="res_price">150 000,00 €</p>
                                            <p class="res_title"> MORADIA T4</p>
                                            <p class="res_sub"> TELHEIRO | BARREIRA | LEIRIA</p>
                                        </div>
                                    </div>
                                </div>
                                <div class="column">
                                    <div class="re-img" style="background-image: url('/static/images/feat_property/casa.jpg'); background-position: center; background-size: cover">
                                        <div class="re-card" >
                                            <p class="res_price">150 000,00 €</p>
                                            <p class="res_title"> MORADIA T4</p>
                                            <p class="res_sub"> TELHEIRO | BARREIRA | LEIRIA</p>
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <div class="columns">
                                <div class="column">
                                    <div class="re-img" style="background-image: url('/static/images/feat_property/casa.jpg'); background-position: center; background-size: cover">
                                        <div class="re-card" >
                                            <p class="res_price">150 000,00 €</p>
                                            <p class="res_title"> MORADIA T4</p>
                                            <p class="res_sub"> TELHEIRO | BARREIRA | LEIRIA</p>
                                        </div>
                                    </div>
                                </div>
                                <div class="column">
                                    <div class="re-img" style="background-image: url('/static/images/feat_property/casa.jpg'); background-position: center; background-size: cover">
                                        <div class="re-card" >
                                            <p class="res_price">150 000,00 €</p>
                                            <p class="res_title"> MORADIA T4</p>
                                            <p class="res_sub"> TELHEIRO | BARREIRA | LEIRIA</p>
                                        </div>
                                    </div>
                                </div>
                                <div class="column">
                                    <div class="re-img" style="background-image: url('/static/images/feat_property/casa.jpg'); background-position: center; background-size: cover">
                                        <div class="re-card" >
                                            <p class="res_price">150 000,00 €</p>
                                            <p class="res_title"> MORADIA T4</p>
                                            <p class="res_sub" style="text-transform: uppercase;"> União das Freguesias | Pousos | Cortes e Leiria</p>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div style="text-align: center; margin:2rem 0 0; padding:2rem 0 0;">
                            <a class="button is-primary" style="font-weight:600;">VER MAIS</a>

                        </div>



                    </div>

                </div>

            </section>




            <section id="addons">
                <div class="container" style="padding-left: 0.5rem; padding-right:0.5rem;">
                    <div class="bluebar">
                        <span>PEÇA O SEU CRÉDITO HABITAÇÃO ONLINE! <b>SIMPLES E RÁPIDO</b></span> <a class="button3 is-primary">PRÉ-APROVAÇÃO&nbsp;</a>
                    </div>

                    <div class="graybar">
                        <div class="columns" style="padding:0; margin:0">
                            <div class="column " style="padding:3.0rem">
                                <span style="line-height: 0.5rem;" >A <b>CERTIFICAÇÃO ENERGÉTICA</b> É OBRIGATÓRIA PARA A PROMOÇÃO DO SEU IMÓVEL.</span>

                                <div class="line">
                                    <a class="button is-outlined is-primary" style="font-size: 1.25rem; font-weight:700;" @click="service = cert; orderModal = true;">PEÇA AQUI</a>

                                </div>




                            </div>
                            <div class="column cert" style="padding:0; margin:0">
                                <!--
                                                            <img src="/images/imoveis/Certificado.png" alt="">
                                -->
                            </div>
                        </div>
                    </div>
                </div>


            </section>

            <app-why-use></app-why-use>

            <app-modal-order :service="service" :orderModal="orderModal" v-on:closeOrderModal="orderModal = false"></app-modal-order>


        </div>

    </div>

</template>

<script>
import AppTopBar from "../components/TopBar";

import PlaceDropDown from "../components/PlaceDropDown";
import SearchDropDown from "../components/SearchDropDown";
import AppModalOrder from "../components/ModalOrder";
import AppWhyUse from "../components/WhyUse.vue";
import helpers from "../plugins/helpers";

export default {
  components: {
    AppTopBar,
    PlaceDropDown,
    SearchDropDown,
    AppModalOrder,
    AppWhyUse
  },

  data() {
    return {
      helpers,

      services: this.$route.meta.services,
      banner: this.$route.meta.banner,

      search: {
        type: null,
        size: null,
        place: {
          cod_distrito: null,
          cod_concelho: null,
          cod_localidade: null
        }
      },

      sort: 1,

      service: null,
      orderModal: false,

      type: 0,
      typeopt: [
        "Tipo de Imóvel",
        "Apartamento",
        "Moradia",
        "Terreno",
        "Comércio",
        "Outro"
      ],
      ddfk_type_open: false,

      size: 0,
      sizeopt: ["Tipologia", "T0", "T1", "T2", "T3", "T4", "T5", "T6+"],
      ddfk_size_open: false,

      ddfakeopen: false,

      cert: {
        id: 311,
        title: "Certifica\u00e7\u00e3o Energ\u00e9tica de edificios",
        sub_group_id: 55,
        created_at: null,
        updated_at: null
      },

      topbar: false
    };
  },

  computed: {
    subjectReset: function() {
      return this.subject === "Assunto";
    }
  },

  watch: {
    "$route.name": function() {
      this.services = this.$route.meta.services;
      this.banner = this.$route.meta.banner;
    }
  },

  methods: {
    setPlace(data) {
      this.search.place = data;
    },

    handleScroll(event) {
      let bar = document.getElementById("servicesbar");

      this.topbar = !helpers.isScrolledIntoView(bar);
    }
  },

  destroyed() {
    window.removeEventListener("scroll", this.handleScroll);
  },

  created() {
    this.messageModal = this.$route.params.message;
    window.addEventListener("scroll", this.handleScroll);
  }
};
</script>
<style scoped>
.sort {
  color: #969696;
}

.selected {
  color: #e90054;
}

.sort:hover {
  color: #e90054;
}

.searchbar {
  padding: 1rem 3rem;
  background-color: #2d3256;
  color: white;
  font-size: 1.25rem;
  font-weight: 400;
  border-top: solid 8px #e90054;
}

.searchbarbtn {
  display: flex;
  align-items: center;
  justify-content: space-between;
  flex-direction: row;
}

.bluebar {
  padding: 1.5rem 3rem;
  background-color: #2d3256;
  color: white;
  font-size: 1.25rem;
  font-weight: 400;
  border-bottom: solid 8px #e90054;
  display: flex;
  align-items: center;
  justify-content: space-between;
  flex-direction: row;
}

.graybar {
  border-top: solid 8px #e90054;

  background-color: #d4d4d4;
  color: #e90054;
  font-size: 1.25rem;
  font-weight: 400;
}

.graybar .columns {
  padding: 1.25rem 3rem;
}

.button3 {
  font-size: 1.25rem;
  padding: 1.2rem 1rem;
  font-weight: 700;
}

.icontitle {
  padding: 14rem 0 2rem;
  text-align: center;
  color: white;
}

.icontitle h2 {
  text-align: center;
  color: white;
  font-size: 2.3rem;
  font-weight: 700;
}

.icontitle img {
  text-align: center;
  color: white;
  margin: auto;
}

h1 {
  font-weight: 500;
  font-size: 2.3rem;
  line-height: 1.15;
  color: #2d3256;
  margin: 3rem 0 0.5rem;
  padding: 0 2rem;
  text-align: center;
}

#f-lv1-search {
  background-position: center 3.5rem;
  background-size: cover;
  background-repeat: no-repeat;
  min-height: 28rem;
  margin-top: -14rem;
}

.line {
  margin-top: 1.5rem;
  border-top: solid 1px #969696;
  padding: 1.5rem 1.5rem 0;
  text-align: center;
}

.cert {
  background-image: url("/static/images/imoveis/Certificado.png");
  //background-size: cover;
  background-position: top left;
}

#addons {
  margin-top: 9rem;
  margin-bottom: 6rem;
}

.fakeddcontainer {
  position: relative;
  margin-right: 0.75rem;
}

.fakedd {
  position: relative;
  //margin: 1.5rem 0 0;
  border: solid 1px #ffffff;
  line-height: 2rem;
  padding: 0 0.5rem;
  font-size: 0.8rem;
  min-height: 2rem;
  min-width: 12rem;
  color: #ffffff;
}

.ddfake-open {
  background-color: white;
  position: absolute;
  z-index: 2;
  width: 100%;
  border: solid 1px #969696;
}

.ddfake-opt {
  font-size: 0.8rem;
  color: black;
  line-height: 2rem;
  z-index: 3;
  cursor: pointer;
  padding: 0 0.5rem;
}

.ddfake-opt:hover {
  color: white;
  background-color: #2d3256;
}

.orderby {
  display: flex;
  align-items: center;
  justify-content: space-between;
  flex-direction: row;
  margin-left: auto;

  font-size: 0.8rem;
  min-height: 2rem;
  min-width: 8rem;
  white-space: nowrap;
  color: #ffffff;
}

.orderbysub {
  display: flex;
  align-items: center;
  justify-content: space-between;
  flex-direction: row;
  margin-left: 0.25rem;
}

.sort {
  line-height: 2rem;
  height: 2.5rem;
  margin-left: 0.1rem;
}

.searchresults h1 {
  font-weight: 700;
  font-size: 1.5rem;
  margin-bottom: 4rem;
}

.searchresults .column {
  padding: 0.25rem;
}

.re-card {
  /* Permalink - use to edit and share this gradient: http://colorzilla.com/gradient-editor/#000000+0,000000+100&0+0,0.5+100 */
  background: -moz-linear-gradient(
    top,
    rgba(0, 0, 0, 0) 0%,
    rgba(0, 0, 0, 0.5) 100%
  ); /* FF3.6-15 */
  background: -webkit-linear-gradient(
    top,
    rgba(0, 0, 0, 0) 0%,
    rgba(0, 0, 0, 0.5) 100%
  ); /* Chrome10-25,Safari5.1-6 */
  background: linear-gradient(
    to bottom,
    rgba(0, 0, 0, 0) 0%,
    rgba(0, 0, 0, 0.5) 100%
  ); /* W3C, IE10+, FF16+, Chrome26+, Opera12+, Safari7+ */
  filter: progid:DXImageTransform.Microsoft.gradient( startColorstr='#00000000', endColorstr='#80000000',GradientType=0 ); /* IE6-9 */
  padding: 1rem;
}

.re-img {
  padding: 0rem;
}

.res_price {
  padding-top: 9rem;
  color: white;
  font-size: 1.5rem;
  font-weight: 600;
}

.res_title {
  color: white;
  font-size: 0.6rem;
  font-weight: 400;
}

.res_sub {
  color: white;
  font-size: 0.6rem;
  font-weight: 300;
}
</style>



// WEBPACK FOOTER //
// src/pages/RealEstate.vue